/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Protocol_Beginner_Full_Body_Fast_Split_NameInputs */

const en_us2_protocol_beginner_full_body_fast_split_name = /** @type {(inputs: Protocol_Beginner_Full_Body_Fast_Split_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginner · early split`)
};

const pt_br2_protocol_beginner_full_body_fast_split_name = /** @type {(inputs: Protocol_Beginner_Full_Body_Fast_Split_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciante · divisão antecipada`)
};

const es_419_protocol_beginner_full_body_fast_split_name = /** @type {(inputs: Protocol_Beginner_Full_Body_Fast_Split_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante · división anticipada`)
};

const pt_pt2_protocol_beginner_full_body_fast_split_name = /** @type {(inputs: Protocol_Beginner_Full_Body_Fast_Split_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante · divisão antecipada`)
};

const fr_fr2_protocol_beginner_full_body_fast_split_name = /** @type {(inputs: Protocol_Beginner_Full_Body_Fast_Split_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Débutant · répartition anticipée`)
};

const de_de2_protocol_beginner_full_body_fast_split_name = /** @type {(inputs: Protocol_Beginner_Full_Body_Fast_Split_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anfänger · früher Split`)
};

const it_it2_protocol_beginner_full_body_fast_split_name = /** @type {(inputs: Protocol_Beginner_Full_Body_Fast_Split_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Principiante · split anticipato`)
};

/**
* | output |
* | --- |
* | "Beginner · early split" |
*
* @param {Protocol_Beginner_Full_Body_Fast_Split_NameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const protocol_beginner_full_body_fast_split_name = /** @type {((inputs?: Protocol_Beginner_Full_Body_Fast_Split_NameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Protocol_Beginner_Full_Body_Fast_Split_NameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_protocol_beginner_full_body_fast_split_name(inputs)
	if (locale === "es-419") return es_419_protocol_beginner_full_body_fast_split_name(inputs)
	if (locale === "pt-PT") return pt_pt2_protocol_beginner_full_body_fast_split_name(inputs)
	if (locale === "fr-FR") return fr_fr2_protocol_beginner_full_body_fast_split_name(inputs)
	if (locale === "de-DE") return de_de2_protocol_beginner_full_body_fast_split_name(inputs)
	if (locale === "it-IT") return it_it2_protocol_beginner_full_body_fast_split_name(inputs)
	return en_us2_protocol_beginner_full_body_fast_split_name(inputs)
});
export { protocol_beginner_full_body_fast_split_name as "protocol.beginner-full-body-fast-split.name" }